import React, { useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { useTranslation } from 'react-i18next';
import { HashLink as Link } from 'react-router-hash-link';

const Price = () => {

    const [updater, setUpdater] = useState(1);

    const { t, i18n } = useTranslation()
 
    i18n.on('languageChanged', () => {
       setTimeout(() => setUpdater(updater + 1), 100)
    })

    // OwlCarousel Option for Prices
    const options = {
        0: {
            items: 1,
            dots: true,
            margin: 5,
            startPosition: 2
        },
        600: {
            items: 1,
            dots: true,
            margin: 0,
            startPosition: 2
        },
        768: {
            items: 2,
            dots: true,
            startPosition: 2
        },
        992: {
            items: 3,
        },
        1000: {
            items: 3
        }
    };

    // Dynamic Price Data Easy to Update
    let data = [
        {
            title: t('basic'),
            label: t('basic label'),
            price: 'XXX',
            period : t('basic period'),
            features: ['basic fea-1', 'basic fea-2', 'basic fea-3', 'basic fea-4', 'basic fea-5', 'basic fea-6', 'basic fea-7', 'basic fea-8', 'basic fea-9', 'basic fea-10', 'basic fea-11']
            //features: '<li>1 GB of space</li><li>real time sync</li><li>unlimited attachment</li><li>customize theme</li><li>priority email support</li>', link: '#'
        },
        {
            title: t('standard'),
            label: t('standard label'),
            price: 'XXX',
            period : t('standard period'),
            features: ['standard fea-1', 'standard fea-2', 'standard fea-3', 'standard fea-4', 'standard fea-5', 'standard fea-6', 'standard fea-7', 'standard fea-8', 'standard fea-9', 'standard fea-10', 'standard fea-11']
            //features: '<li>1 GB of space</li><li>real time sync</li><li>unlimited attachment</li><li>customize theme</li><li>priority email support</li>', link: '#'
        },
        {
            title: t('premium'),
            label: t('premium label'),
            price: 'XXX',
            period : t('premium period'),
            features: ['premium fea-1', 'premium fea-2', 'premium fea-3', 'premium fea-4', 'premium fea-5', 'premium fea-6', 'premium fea-7', 'premium fea-8', 'premium fea-9', 'premium fea-10', 'premium fea-11']
            //features: '<li>1 GB of space</li><li>real time sync</li><li>unlimited attachment</li><li>customize theme</li><li>priority email support</li>', link: '#'
        },
    ];

    // Dynamic Price Data Loop
    let DataList = data.map((val, i) => {

        const features = val.features.map((feature) => {
            return (
                <li>
                    {t(feature)}
                </li>)
        })

        return (

            <div className="price-item" key={i}>
                <div className="price-block">
                    <div className="price-type">
                        <h2>{val.title}</h2>
                    </div>
                    <div className="mrp">
                        <h6 className="user-type">{val.label}</h6>
                        <div className="price-devide"></div>
                        {/* <h2>{val.price}€</h2> */}
                        <h3>{t('invoicing')}</h3>
                        <h6 className="price-year">{val.period}</h6>
                        <div className="price-devide"></div>
                    </div>
                    <ul className="price-feature">
                        {features}
                    </ul>
                    <Link to="/#contact" smooth className="btn btn-custom theme-color" role="button" >{t('request offer')}</Link>
                </div>
            </div>
        );
    });

    return (
        <section id="price" className="price">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <OwlCarousel
                            className="price-carousel owl-carousel owl-theme"
                            loop={true}
                            margin={30}
                            nav={false}
                            dots={false}
                            responsive={options}
                        >
                            {DataList}
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Price;


// WEBPACK FOOTER //
// ./src/components/price.js